<template>
  <el-dialog
    :lock-scroll="false"
    :close-on-click-modal="false"
    title="添加"
    :visible.sync="dialogFormVisible"
    width="700px"
    @close="onCancleBtn"
  >
    <div class="ad-content">
      <el-upload
        class="avatar-uploader"
        :action="'/img/oss/upload'"
        :show-file-list="false"
        :data="{ pathName: 'advertisment' }"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <el-form
        class="fl"
        style="width: 500px"
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="100px"
        id="form"
      >
        <el-form-item label="图片地址:" prop="picUrl">
          <el-input v-model.trim="form.picUrl" readonly></el-input>
        </el-form-item>
        <el-form-item label="url:" prop="url">
          <el-input v-model.trim="form.url"></el-input>
        </el-form-item>
        <el-form-item label="开始时间:" prop="startTime">
          <el-date-picker
            v-model.trim="form.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker
            v-model.trim="form.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序:" prop="sequence">
          <el-input v-model.trim="form.sequence"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirmBtn">确 定</el-button>
      <el-button @click="onCancleBtn">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { editOneAdvertisement } from "@/api/url";
export default {
  data() {
    var checkUrl = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入url"));
      } else {
        const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
        if (!urlregex.test(value)) {
          callback(new Error("url输入不正确"));
        } else {
          callback();
        }
      }
    };
    var checkStartTime = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入开始时间"));
      } else {
        if (this.form.endTime) {
          const bdate =new Date(Date.parse(this.form.endTime.replace(/-/g, "/"))).getTime();
          const edate = new Date(Date.parse(this.form.startTime.replace(/-/g, "/"))).getTime();
          if (bdate - edate < 0) {
            callback(new Error("开始时间大于结束时间"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkEndTime = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入结束时间"));
      } else {
        if (this.form.startTime) {
          const bdate =new Date(Date.parse(this.form.endTime.replace(/-/g, "/"))).getTime();
          const edate =new Date(Date.parse(this.form.startTime.replace(/-/g, "/"))).getTime();
          if (bdate - edate < 0) {
            callback(new Error("结束时间小于开始时间"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    return {
      dialogFormVisible: true,
      nodeEnv: "",
      imageUrl: "",
      form: {
        picUrl: "",
        url: "",
        startTime: "",
        endTime: "",
        sequence: 0,
      },
      rules: {
        picUrl: [{ required: true, message: "请上传图片" }],
        url: [
          // { required: true, message: "请填写url", trigger: "blur" },
          { validator: checkUrl, trigger: "blur" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: ["blur", "change"],
          },
          { validator: checkStartTime, trigger: "blur" },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: ["blur", "change"],
          },
          { validator: checkEndTime, trigger: "blur" },
        ],
        sequence: [
          {
            required: true,
            message: "请填写排序",
            trigger: "blur",
          },
          {
            type: "number",
            message: "请填写数字",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.nodeEnv = process.env.NODE_ENV;
  },
  methods: {
    handleAvatarSuccess(res, file) {
      const { data, status } = res;
      if (status !== 200) {
        this.$message.error(res.message);
      }
      this.form.picUrl = res.data;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    onCancleBtn() {
      this.dialogFormVisible = false;
      this.$emit("func", "cancle");
    },
    onConfirmBtn() {
      this.$postRequest(editOneAdvertisement(), this.form).then((r) => {
        const { status, data } = r;
        if (status === 200) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.dialogFormVisible = false;
          this.$emit("func", "add");
        } else {
          this.$message.error(r.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.ad-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    max-width: 100%;
    width: 100%;
  }
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>